var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function pointCloudTilesetFlyover1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Point Cloud Tileset Flyover 1" +
                "</h1>" +
                "<p>" +
                "The camera will fly over a point cloud tileset. The tileset should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 2;
        const durations = [0, initialWait, time, time, time, time, time, time, time];
        const positions = [
            { longitude: 2.5374981420641376, latitude: -0.6643123827760543, height: 43.96268243486276 },
            { longitude: 2.5374981420641376, latitude: -0.6643123827760543, height: 43.96268243486276 },
            { longitude: 2.5374943928717983, latitude: -0.6643286087845304, height: 44.7690560938964 },
            { longitude: 2.537506636399636, latitude: -0.6643329548174669, height: 42.35032132794055 },
            { longitude: 2.537519116248701, latitude: -0.6643374566901261, height: 58.123338255603265 },
            { longitude: 2.537529611157187, latitude: -0.6643263427674682, height: 55.900723172685275 },
            { longitude: 2.5375278065756195, latitude: -0.6643105124603049, height: 42.414574411269676 },
            { longitude: 2.537406915822658, latitude: -0.6643082553660649, height: 487.4422008759856 },
            { longitude: 2.5375237776394393, latitude: -0.66421232407774, height: 49.057417463261466 },
        ];
        const focuses = [
            { longitude: 2.5374995822237016, latitude: -0.6643182809018432, height: 41.62727032293877 },
            { longitude: 2.5374995822237016, latitude: -0.6643182809018432, height: 41.62727032293877 },
            { longitude: 2.5374995822237016, latitude: -0.6643182809018432, height: 41.62727032293877 },
            { longitude: 2.5375092273089797, latitude: -0.6643318250468955, height: 42.391393362395576 },
            { longitude: 2.537518251218649, latitude: -0.6643335054905947, height: 45.475711352630924 },
            { longitude: 2.537524740577227, latitude: -0.664326857693576, height: 45.06029015975664 },
            { longitude: 2.5375381990319585, latitude: -0.6643124800907861, height: 41.559658880553194 },
            { longitude: 2.5374727249233713, latitude: -0.6643045232222843, height: 180.3961803575651 },
            { longitude: 2.5375189359631327, latitude: -0.6642338498897538, height: 44.90100192324758 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), durations, positions, focuses, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/BruntRoad/tileset.json",
                style: {
                    pointSize: 2,
                },
            });
            renderer.getWorld().addObject(object);
        }));
    });
}
